import React,{ Component } from "react";
import { connect } from "react-redux";
import { getLdap, deleteLdap, testLdapConfig } from "../../actions/actionLdap";
import ReactTable from "react-table";
import { Link } from "react-router-dom";
import { Field, reduxForm } from "redux-form";
import { Row, Col, Button, Modal, ModalHeader,  Form, 
    FormGroup, ModalBody, ModalFooter, UncontrolledTooltip, Card, CardBody, CardHeader } from "reactstrap";
import { NotificationManager } from "react-notifications";
import LoadingSpinner from "../../components/LoadingSpinner/index";
import { withRouter } from "react-router-dom";
import "react-table/react-table.css";
import { renderField, required } from "../../utils/formValidations.js";
import Proptypes from "prop-types";
import BreadCrumbCompo from "../../components/Breadcrumb/BreadCrumbCompo";
import { fuzzySearch } from "../../utils/helpers";

const routes = [
    {name: "Home",path:"/userdashboard",isActive: false},
    {name: "Ldap",path:"/ldap",isActive: true}
];

class Ldap extends Component{
    constructor(props){
        super(props);
        this.state = {
            modal: false,
            modalldap: false,
            pages: 1,
            ldapId: null,
            password: "",
        };
        this.ldapConfirm = this.ldapConfirm.bind(this);
        this.submitLdapConfig = this.submitLdapConfig.bind(this);
        this.deleteConfirm = this.deleteConfirm.bind(this);
        this.deleteLdapAction = this.deleteLdapAction.bind(this);
        this.handleDeleteSuccess = this.handleDeleteSuccess.bind(this);
        this.handleDeleteError = this.handleDeleteError.bind(this);
        this.toggle1 = this.toggle1.bind(this);
        this.cancelDelete = this.cancelDelete.bind(this);
    }

    ldapConfirm(ldapId){
        this.setState({modalldap: !this.state.modalldap,
            ldapId: ldapId
        });
    }

    submitLdapConfig(userData){
        let currentLdap = this.props.ldap_configs.find(ldap => ldap.ldap_id === this.state.ldapId);
        currentLdap.ldapId = this.state.ldapId,
        currentLdap.username = userData.username;
        currentLdap.password = userData.password;
        this.props.testLdapConfig(currentLdap).
            then(() => this.handleLdapConfigSuccess()).
            catch(() => this.handleLdapConfigFailure());
    }

    handleLdapConfigSuccess(){
        const {TestLdapConfigErrorMessage} = this.props; 
        if(TestLdapConfigErrorMessage){
            NotificationManager.error(TestLdapConfigErrorMessage,"Test LDAP Config", 3000);
        }
        else{
            NotificationManager.success("Test LDAP", "TEST LDAP Config Successfully");
            this.setState({modalldap: false});
        }
    }

    handleLdapConfigFailure(){
        const {TestLdapConfigError} = this.props;
        if(TestLdapConfigError){
            NotificationManager.error(TestLdapConfigError,"Create Group", 3000);
        }
        else{
            NotificationManager.error("Something Went Wrong!!", "Test LDAP Failed");
            this.setState({modalldap: false});
        }
    }

    componentDidMount() {
        this.props.getLdap();
    }

    deleteConfirm(ldapId){
        this.setState({modal: !this.state.modal,
            ldapId: ldapId});
    }

    cancelDelete(){
        this.setState({modal: !this.state.modal}); 
    }

    toggle1(){
        this.setState({modalldap: !this.state.modalldap});
        this.props.initialize({ username: "", password: "" });
    }

    deleteLdapAction(){
        this.props.deleteLdap(this.state.ldapId).
            then(() => this.handleDeleteSuccess()).
            catch(() => this.handleDeleteError());
    }   

    handleDeleteSuccess(){
        const {deleteLdapErrorMessage} = this.props;
        if(deleteLdapErrorMessage) {
            NotificationManager.error(deleteLdapErrorMessage,"Failed to Delete Ldap", 3000);
        }else{
            NotificationManager.success("Ldap Deleted Successfully","Delete Ldap", 3000);
            this.setState({modal: false});
            this.props.getLdap();
        }
    }

    handleDeleteError(){
        const {deleteLdapError} = this.props;
        if(deleteLdapError){
            NotificationManager.error(deleteLdapError,"Failed to Delete Ldap", 3000);
            this.props.history.push("/ldap");
        }else{
            NotificationManager.error("Failed to Delete Ldap","Delete Ldap", 3000);
            this.props.history.push("/ldap");
        }
    }

    render(){
        if (this.props.getLdapLoading){
            return (<div> <LoadingSpinner /></div>);
        }
        const { ldap_configs, handleSubmit } = this.props;
        const { loading } = this.state;

        const columns = [
            {   Header: "Name",
                accessor: "name",
                filterMethod: fuzzySearch
            },
            {
                Header: "LDAP URL",
                accessor: "url",
                filterMethod: fuzzySearch
            },
            {
                Header: "Actions",
                filterable: false,
                sortable: false,
                Cell: (data) => (<div className="action-btn">
                    <Link className="btn btn-success" id={"TooltipComponent"} to={{ pathname: `/viewldap/${data.original.ldap_id}` }}><i className="fa fa-eye"></i></Link>
                    <Link className="btn btn-warning" id={"Tooltipss"} to={{ pathname: `/updateldap/${data.original.ldap_id}` }}><i className="fa fa-pencil"></i> </Link>                                    
                    <button className="btn btn-danger"  id={"Tooltips"} href="#"  onClick={() => this.deleteConfirm(data.original.ldap_id)}>
                        <i className="fa fa-trash-o"></i> </button>
                    <button className="btn btn-info" id={"Tooltipps"} href="#"  onClick={() => this.ldapConfirm(data.original.ldap_id)}>
                        <i className="fa fa-key"></i> </button>     
                    <UncontrolledTooltip placement="right" target={"TooltipComponent"}> View </UncontrolledTooltip>
                    <UncontrolledTooltip placement="right" target={"Tooltipss"}> Edit </UncontrolledTooltip>
                    <UncontrolledTooltip placement="right" target={"Tooltips"}> Delete </UncontrolledTooltip>
                    <UncontrolledTooltip placement="right" target={"Tooltipps"}> Test LDAP Connection </UncontrolledTooltip>
                </div>
                ),
            }];
        return (
            <div> 
                <BreadCrumbCompo routes={routes}/> 
                <Row>
                    <Col sm={{ size: 10, order: 3, offset: 1 }}>
                        <Card >
                            <CardHeader>
                                <i className="fa fa-align-justify"></i> <strong>LDAP Configurations</strong>
                                <Link className="pull-right" to={{ pathname: "/createldap" }}>
                                    <Button className="pull-right" size="sm" color="dark">
                                   Create New Configuration
                                    </Button>
                                </Link> 
                            </CardHeader>
                            <CardBody>
                                <ReactTable
                                    columns={columns}
                                    data={ldap_configs}
                                    defaultSorted={[{ id: "name" }]}
                                    loading={loading}
                                    filterable
                                    defaultPageSize={10}
                                    className="-striped -highlight site_table"
                                />
                            </CardBody>
                        </Card>
                    </Col>
                </Row>

                <Modal isOpen={this.state.modalldap} toggle1={this.toggle1} className={this.props.className}> 
                    <Form onSubmit={handleSubmit(this.submitLdapConfig)}>
                        <ModalHeader toggle1={this.toggle1}><i className="fa fa-align-justify"></i>  Test LDAP Connection <i className="fa fa-key" aria-hidden="true"></i>
                        </ModalHeader>
                        <ModalBody>
                            <FormGroup>
                                <Row>
                                    <Col sm="5">
                                        <label className="requiredasterisk"> Test User Name </label>
                                    </Col>
                                    <Col sm="6">
                                        <Field 
                                            id="username"
                                            type="username"
                                            name="username"
                                            component={renderField} 
                                            validate={[required]}
                                        /> 
                                    </Col>
                                </Row>
                            </FormGroup>
                            <FormGroup>
                                <Row>
                                    <Col sm="5">
                                        <label className="requiredasterisk">Test Password </label>
                                    </Col>
                                    <Col sm="6">
                                        <Field
                                            id="password"
                                            type="password"
                                            name="password"
                                            component={renderField}
                                            validate={[required]}
                                        />                                            
                                    </Col>
                                </Row>
                            </FormGroup> 
                        </ModalBody>
                        <ModalFooter>
                            <Button type="submit" size="sm" color="primary"> <i className="fa fa-dot-circle-o"></i> Test Connection</Button>
                            <Button onClick={this.toggle1} size="sm" color="basic"><i className="fa fa-ban"></i> Cancel</Button>
                        </ModalFooter>
                    </Form>  
                </Modal>

                <Modal isOpen={this.state.modal} toggle={this.cancelDelete} className={this.props.className}>
                    <ModalHeader toggle={this.cancelDelete}>Delete LDAP Configuration <i className="fa fa-bomb" aria-hidden="true"></i>
                    </ModalHeader>
                    <ModalBody>
                  Confirm Delete LDAP Configuration?
                    </ModalBody>
                    <ModalFooter>
                        <Button onClick={this.deleteLdapAction} size="sm" color="danger"> <i className="fa fa-trash"></i> Delete</Button>
                        <Button onClick={this.cancelDelete} size="sm" color="basic"><i className="fa fa-ban"></i> Close</Button>
                    </ModalFooter>
                </Modal>
            </div>
        );
    }
}

Ldap.propTypes = {
    getLdap: Proptypes.func.isRequired,
    deleteLdap: Proptypes.func.isRequired,
    deleteLdapErrorMessage: Proptypes.func,
    TestLdapConfigErrorMessage: Proptypes.string,
    testLdapConfig: Proptypes.func.isRequired,
    deleteLdapError: Proptypes.func,
    history: Proptypes.object.isRequired,
    ldap: Proptypes.array,
    getLdapLoading: Proptypes.bool,
    initialize: Proptypes.func,
    ldap_configs: Proptypes.array,
    handleSubmit:  Proptypes.func,
    className: Proptypes.func,
    TestLdapConfigError: Proptypes.string
};

let  LdapFormWithRouter = withRouter(Ldap);

let LdapForm = connect(state => ({
    ldap_configs: state.ldap_configs.ldap_configs || [],
    getLdapLoading: state.ldap_configs.getLdapLoading || false,
    deleteLdapErrorMessage: state.ldap_configs.deleteLdapErrorMessage || null,
    deleteLdapLoading: state.ldap_configs.deleteLdapLoading || false,
    deleteLdapError: state.ldap_configs.deleteLdapError || null,
    TestLdapConfigErrorMessage: state.ldap_configs.TestLdapConfigErrorMessage || null,
    TestLdapConfigLoading: state.ldap_configs.TestLdapConfigLoading || null,
}), 
dispatch => ({
    getLdap: () => dispatch(getLdap()),
    testLdapConfig: (data) => dispatch(testLdapConfig(data)),
    deleteLdap: (data) => dispatch(deleteLdap(data))
}))(LdapFormWithRouter);

export default reduxForm({
    form: "ldapForm",
})(LdapForm);


// WEBPACK FOOTER //
// ./src/views/Ldap/Ldap.js